import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer-container">
      <p>📮 Contact: <a href="mailto:contact@ourjob.in">contact@ourjob.in</a></p>

      <p>
        🔗 Helpful govt Links:&nbsp;
        <a href="https://upsc.gov.in" target="_blank" rel="noopener noreferrer">UPSC</a> |&nbsp;
        <a href="https://ssc.gov.in" target="_blank" rel="noopener noreferrer">SSC</a> |&nbsp;
        <a href="https://indianrailways.gov.in/" target="_blank" rel="noopener noreferrer">Railways</a> |&nbsp;

      </p>

      <p>
        🔗 PSUs Links :&nbsp;
        <a href="https://www.isro.gov.in/Careers.html" target="_blank" rel="noopener noreferrer">ISRO</a> |&nbsp;
        <a href="https://rac.gov.in/index.php" target="_blank" rel="noopener noreferrer">DRDO</a>|&nbsp;
        <a href="https://barcocesexam.in/" target="_blank" rel="noopener noreferrer">BARC</a> |&nbsp;
      </p>
      <div className="disclaimer">
        <p style={{fontSize:'0.8rem'}}>
          ⚠️ <strong>Disclaimer:</strong> The job portal www.ourjob.in is an independent job information portal. We do not create or own the official job content. All job listings are sourced from respective government, public sector organizations and others. Users are advised to verify details from the official advertisement before applying.
        </p>
      </div>

      <p>© 2025 OurJob. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
